import { render, staticRenderFns } from "./MapLegendItem.vue?vue&type=template&id=54af8c70&"
import script from "./MapLegendItem.vue?vue&type=script&lang=js&"
export * from "./MapLegendItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports